/**
 * Derive the S3 object key for a JPEG thumbnail sibling of a full-size image.
 * Must stay in sync with backend ThumbnailService.generateThumbnailObjectKey.
 */
export function deriveThumbnailObjectKey(originalObjectKey) {
    const lastSlashIndex = originalObjectKey.lastIndexOf('/');
    const thumbFilename = thumbnailFilenameFromOriginal(lastSlashIndex === -1
        ? originalObjectKey
        : originalObjectKey.substring(lastSlashIndex + 1));
    if (lastSlashIndex === -1) {
        return `thumbnails/${thumbFilename}`;
    }
    const path = originalObjectKey.substring(0, lastSlashIndex);
    return `${path}/thumbnails/${thumbFilename}`;
}
function thumbnailFilenameFromOriginal(originalFilename) {
    const lastDotIndex = originalFilename.lastIndexOf('.');
    if (lastDotIndex === -1) {
        return `${originalFilename}-thumb.jpg`;
    }
    const nameWithoutExt = originalFilename.substring(0, lastDotIndex);
    return `${nameWithoutExt}-thumb.jpg`;
}
/** Prefer stored thumbnail key, else conventional derived key. */
export function resolveThumbnailObjectKey(objectKey, thumbnailObjectKey) {
    const stored = thumbnailObjectKey?.trim();
    if (stored) {
        return stored;
    }
    return deriveThumbnailObjectKey(objectKey);
}
//# sourceMappingURL=thumbnail-object-key.js.map